import PasswordResetFinish from './PasswordResetFinish';
export default PasswordResetFinish;
